"use client";

import type { AboutData } from "@/services/public.service";
import Image from "next/image";

export default function AboutHero({ about, isAr }: { about: AboutData; isAr: boolean }) {
  const title = isAr ? about.title.ar : about.title.en;
  const subtitle = isAr ? about.subtitle.ar : about.subtitle.en;
  const img = about.heroImage || "/defaults/banner.jpg";

  // Same ratio as the dashboard spec (1920×720 → 8:3). Phones show the centre 4:3.
  return (
    <section className="relative w-full aspect-[4/3] min-h-[320px] md:aspect-[8/3] md:min-h-0 overflow-hidden">
      <Image src={img} alt={title} fill priority unoptimized className="object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-shade/80 via-shade/40 to-shade/20" />
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <h1 className="font-display text-4xl md:text-6xl font-extrabold text-white drop-shadow mb-4">{title}</h1>
        {subtitle && <p className="text-white/90 max-w-2xl text-lg leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
